import React from 'react';
import Navbar from './Navbar';
import Container from '../common/Container';
import { useAuthContext } from '../../hooks/useAuthContext';
import FloatingStrategyButton from '../common/FloatingStrategyButton';

const PageLayout = ({ children, showProfileMenu = true, banner, isAdminPage = false }) => {
  const { user } = useAuthContext();
  
  return (
    <div className="relative min-h-screen">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-100 via-pink-300 to-purple-500 opacity-10 -z-10"></div>
      {/* Hide Navbar on desktop for authenticated users (they have DesktopSidebar) */}
      <div className={user ? 'block md:hidden' : 'block'}>
        <Navbar 
          banner={banner} 
          forCandidates={false} 
          showProfileMenu={showProfileMenu && !!user} 
        />
      </div>
      <Container>
        <div className={user ? 'mt-1 md:mt-0' : 'mt-4'}>
          {children}
        </div>
        {/* Extra padding at the bottom to ensure floating button doesn't overlap content */}
        <div className="h-20"></div>
      </Container>
      
      {/* Floating Strategy Call Button - Hide on admin pages and mobile */}
      {!isAdminPage && (
        <div className="hidden md:block">
          <FloatingStrategyButton />
        </div>
      )}
    </div>
  );
};

export default PageLayout;
